import React, { useState } from 'react';

const GiftPage = () => {
  const [copied, setCopied] = useState(false);
  const IBAN = "IT00X0000000000000000000000"; // Placeholder

  const handleCopy = () => {
    navigator.clipboard.writeText(IBAN);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <>
      <style>{`
        .gift-page {
          min-height: 100vh;
          padding: 85px 20px 40px; /* Reduced top padding */
          background: #fdfcfb;
          font-family: 'Josefin Sans', sans-serif;
          display: flex;
          flex-direction: column;
          align-items: center;
          text-align: center;
          color: #3a4a5c;
        }

        .gift-container {
          max-width: 600px;
          width: 100%;
          background: white;
          padding: 40px 30px;
          border-radius: 20px;
          box-shadow: 0 10px 40px rgba(138, 196, 208, 0.1);
          border: 1px solid rgba(195, 229, 234, 0.3);
          position: relative;
          overflow: hidden;
          animation: fadeInUp 0.8s ease-out;
        }

        .gift-title {
          font-family: 'Cormorant Garamond', serif;
          font-size: 36px;
          color: #3a4a5c;
          margin-bottom: 20px;
          position: relative;
          z-index: 2;
        }

        .gift-icon-container {
            margin-bottom: 20px;
            color: #f6cdca;
            display: flex;
            justify-content: center;
        }

        /* Animated Heart Styles */
        .heart-svg {
          width: 60px;
          height: 60px;
          overflow: visible;
        }

        .heart-path {
          fill: none;
          stroke: #f6cdca;
          stroke-width: 1.5;
          stroke-linecap: round;
          stroke-linejoin: round;
          stroke-dasharray: 60;
          stroke-dashoffset: 60;
          animation: drawHeart 4s ease-in-out infinite;
        }

        .heart-fill {
          fill: #f6cdca;
          opacity: 0;
          animation: fillHeart 4s ease-in-out infinite;
        }

        @keyframes drawHeart {
          0% { stroke-dashoffset: 60; }
          40% { stroke-dashoffset: 0; }
          80% { stroke-dashoffset: 0; opacity: 1; }
          100% { stroke-dashoffset: 0; opacity: 0; }
        }

        @keyframes fillHeart {
          0%, 40% { opacity: 0; transform: scale(1); }
          60% { opacity: 0.3; transform: scale(1.1); }
          80% { opacity: 0.3; transform: scale(1); }
          100% { opacity: 0; transform: scale(1); }
        }

        .gift-text {
          font-size: 16px;
          line-height: 1.8;
          color: #5a6a7c;
          margin-bottom: 30px;
          font-weight: 300;
        }

        .iban-box {
          background: #f8fbfb;
          border: 1px dashed #8ac4d0;
          padding: 20px;
          border-radius: 12px;
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 10px;
          position: relative;
          transition: all 0.3s ease;
        }

        .iban-box:hover {
            background: #f0f7f8;
            border-style: solid;
        }

        .iban-label {
            font-size: 12px;
            text-transform: uppercase;
            letter-spacing: 2px;
            color: #8ac4d0;
            font-weight: 700;
        }

        .iban-code {
            font-family: 'Courier New', monospace;
            font-size: 18px;
            color: #3a4a5c;
            font-weight: 600;
            word-break: break-all;
        }

        .copy-btn {
            background: #8ac4d0;
            color: white;
            border: none;
            padding: 8px 16px;
            border-radius: 20px;
            cursor: pointer;
            font-family: 'Josefin Sans', sans-serif;
            font-size: 12px;
            text-transform: uppercase;
            letter-spacing: 1px;
            margin-top: 10px;
            transition: background 0.3s;
            display: flex;
            align-items: center;
            gap: 6px;
        }

        .copy-btn:hover {
            background: #7ab4c0;
        }

        .copy-feedback {
            position: absolute;
            top: 10px;
            right: 10px;
            font-size: 12px;
            color: #4caf50;
            opacity: 0;
            transform: translateY(5px);
            transition: all 0.3s;
        }

        .copy-feedback.visible {
            opacity: 1;
            transform: translateY(0);
        }

        @keyframes fadeInUp {
          from { opacity: 0; transform: translateY(20px); }
          to { opacity: 1; transform: translateY(0); }
        }

        /* Decorative Background Elements */
        .decor-circle {
            position: absolute;
            border-radius: 50%;
            background: radial-gradient(circle, rgba(246, 205, 202, 0.2) 0%, transparent 70%);
            z-index: 1;
        }

        .decor-1 { width: 300px; height: 300px; top: -100px; left: -100px; }
        .decor-2 { width: 200px; height: 200px; bottom: -50px; right: -50px; background: radial-gradient(circle, rgba(195, 229, 234, 0.2) 0%, transparent 70%); }

      `}</style>

      <div className="gift-page">
        <div className="gift-container">
            <div className="decor-circle decor-1"></div>
            <div className="decor-circle decor-2"></div>

            <div className="gift-icon-container">
                {/* Animated Heart SVG */}
                <svg className="heart-svg" viewBox="0 0 24 24">
                  {/* The filled version (appears later) */}
                  <path className="heart-fill" d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
                  {/* The stroke version (draws itself) */}
                  <path className="heart-path" d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
                </svg>
            </div>

            <h1 className="gift-title">Il Nostro Viaggio</h1>

            <p className="gift-text">
                La vostra presenza è per noi il dono più prezioso.
                <br /><br />
                Il nostro desiderio più grande è celebrare l'amore con le persone a noi care. 
                Tuttavia, se avete il piacere di farci un pensiero, un contributo al nostro viaggio di nozze ci aiuterebbe a realizzare il sogno di scoprire il mondo insieme.
            </p>

            <div className="iban-box">
                <span className="iban-label">IBAN Sposi</span>
                <span className="iban-code">{IBAN}</span>
                <div className={`copy-feedback ${copied ? 'visible' : ''}`}>Copiato!</div>
                <button className="copy-btn" onClick={handleCopy}>
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
                        <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
                    </svg>
                    Copia IBAN
                </button>
            </div>
            
            <p className="gift-text" style={{fontSize: '14px', marginTop: '30px', fontStyle: 'italic'}}>
                Grazie di cuore ❤️
            </p>
        </div>
      </div>
    </>
  );
};

export default GiftPage;
